import CardPropertyObjectTable from '../../components/Card/CardPropertyObjectTable.vue'

export function getCustomTabsList (config) {
  return [
    {
      key: 'params',
      name: 'Основное',
      props: [
        { key: 'detailedDebits' },
        { key: 'validTools', type: 'objects', component: CardPropertyObjectTable },
        { key: 'ignoreLimits' },
        {
          key: 'stockSources',
          type: 'objects',
          component: CardPropertyObjectTable,
          componentProps: {
            filterType: 'stock',
            formId: 'cardProperty'
          }
        },
        {
          key: 'stockTargets',
          type: 'objects',
          component: CardPropertyObjectTable,
          componentProps: {
            filterType: 'stock',
            formId: 'cardProperty'
          }
        }
      ]
    }
  ]
}
